import { instanceOfReference } from "@perxis-auto/shared";
import "../../../filterChoice/model/selectors/selectFilterHistory.js";
import "../../../filterChoice/model/selectors/selectFilterSortValue.js";
import { selectFilterValues } from "../../../filterChoice/model/selectors/selectFilterValues.js";
import "../../../filterChoice/model/selectors/selectFilterValuesCount.js";
import "../../../filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../filterChoice/model/selectors/selectSlugedFilterValues.js";
import { sortCollectionItems } from "../../../../shared/lib/sort/sortCollectionItems.js";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import { ConstructorWidgetEnum } from "../../../../shared/types/constructor/widget.js";
import { selectFilterItemByKey } from "./selectFilterItemByKey.js";
const makeGroupedFilterItem = (filterItem, filterValuesChoice, filterValuesItem) => {
  const { type, value, props, groupByKey: groupingFilterKey, isGroupFulfilled } = filterItem;
  if (!isGroupFulfilled || !filterValuesItem || !groupingFilterKey) {
    return [filterItem];
  }
  const filterValuesData = filterValuesItem == null ? void 0 : filterValuesItem.data;
  const groupingFilterItemValues = [filterValuesData == null ? void 0 : filterValuesData[groupingFilterKey]].flat();
  const filterItemValues = [filterValuesData == null ? void 0 : filterValuesData[filterItem.key]].flat();
  const groupingFilterValuesChoice = filterValuesChoice == null ? void 0 : filterValuesChoice[groupingFilterKey];
  const isExistValues = !!groupingFilterItemValues.length && !!filterItemValues.length;
  const isReference = isExistValues && instanceOfReference(groupingFilterItemValues == null ? void 0 : groupingFilterItemValues[0]) && instanceOfReference(filterItemValues == null ? void 0 : filterItemValues[0]);
  if (!isReference) {
    return [filterItem];
  }
  const resolvedFilterItemValues = [...filterItemValues];
  const resolvedGroupingFilterItemValues = [...groupingFilterItemValues];
  const isValidGroupingKey = resolvedFilterItemValues.every((value2) => value2 == null ? void 0 : value2[groupingFilterKey]);
  if (!isValidGroupingKey) {
    return [filterItem];
  }
  switch (type) {
    case ConstructorWidgetEnum.FilterCheckboxGroup:
    case ConstructorWidgetEnum.FilterModels:
    case ConstructorWidgetEnum.FilterColorPicker:
    case ConstructorWidgetEnum.FilterDuoColorPicker:
    case ConstructorWidgetEnum.FilterOptions: {
      return [...resolvedGroupingFilterItemValues].sort(sortCollectionItems).reduce((acc, groupingFilterItemValue) => {
        const groupedFilterItemValues = resolvedFilterItemValues.filter((value2) => {
          const ref = value2 == null ? void 0 : value2[groupingFilterKey];
          if (!instanceOfReference(ref)) {
            return false;
          }
          return ref.id === groupingFilterItemValue.id;
        });
        const groupedFilterItemChoiceValues = groupedFilterItemValues.filter((value2) => {
          const ref = value2 == null ? void 0 : value2[groupingFilterKey];
          if (!instanceOfReference(ref) || !Array.isArray(groupingFilterValuesChoice)) {
            return false;
          }
          return groupingFilterValuesChoice.includes(ref.id);
        });
        const groupedFilterItemValueIds = groupedFilterItemValues.map(
          (groupingFilterItemValue2) => groupingFilterItemValue2.id
        );
        const groupedValue = (value || []).filter((id) => groupedFilterItemValueIds.includes(id));
        const groupedOptions = ((props == null ? void 0 : props.options) || []).filter(
          (option) => groupedFilterItemValueIds.includes(option.value)
        );
        const isAllOptionsDisabled = groupedOptions.every((option) => option.disabled);
        const isSelectedGroupedFilterValues = !!groupedValue.length;
        const isSelectedGroupingFilterValues = !!groupedFilterItemChoiceValues.length;
        if (isAllOptionsDisabled || !isSelectedGroupedFilterValues && !isSelectedGroupingFilterValues) {
          return acc;
        }
        return [
          ...acc,
          {
            ...filterItem,
            groupTitle: groupingFilterItemValue.displayName,
            value: groupedValue,
            props: {
              ...props,
              options: groupedOptions
            }
          }
        ];
      }, []);
    }
    case ConstructorWidgetEnum.FilterSelect:
    case ConstructorWidgetEnum.FilterMultipleSelect:
    case ConstructorWidgetEnum.FilterLocation:
    case ConstructorWidgetEnum.FilterSlider:
    case ConstructorWidgetEnum.FilterRangeSlider:
    default:
      return [filterItem];
  }
};
const selectGroupedFilterItemByKey = createAppSelector(
  [
    (_, { filterValuesItem }) => filterValuesItem,
    selectFilterItemByKey,
    selectFilterValues
  ],
  (filterValuesItem, filterItem, filterValuesChoice) => {
    if (!filterItem) {
      return;
    }
    return makeGroupedFilterItem(filterItem, filterValuesChoice, filterValuesItem);
  }
);
export {
  selectGroupedFilterItemByKey
};
